<router-outlet name="popups"></router-outlet>

<div class="p-container">
  <section class="section">
    <div class="section-header">
      <h2 class="section-label">
        {{ "BILLING.SUBSCRIPTION_DETAILS_TITLE" | translate }}
      </h2>
    </div>
    <div class="section-content">
      <div class="plan-features">
        <ng-container *ngIf="mySubscription; else notSubscribedTemp">
          <p>
            <ng-container *ngIf="mySubscription.scheduled">
              {{
                "BILLING.MY_SCHEDULE_PLAN_INFO"
                  | translate
                    : {
                        planName: mySubscription.planSnapshot.name | titlecase,
                        scheduledPlanName: mySubscription.scheduled.planSnapshot.name | titlecase,
                        currentEndAt: mySubscription.scheduled.applyAt | date: "MMMM dd, yyyy",
                      }
              }}
            </ng-container>

            <ng-template #withoutScheduled>
              {{ "BILLING.MY_PLAN_INFO" | translate: { planName: mySubscription.planSnapshot.name | titlecase } }}
            </ng-template>
          </p>
          <app-plan-features-list [planFeatures]="mySubscription.aggregatedFeatures"></app-plan-features-list>
        </ng-container>
        <ng-template #notSubscribedTemp>
          <p>Subscribe Now!</p>
        </ng-template>
        <div class="d-flex gap-10 mt-4">
          <sxw-button
            theme="sxw-theme"
            [label]="mySubscription ? 'BILLING.ACTIONS.MANAGE_SUBSCRIPTION' : 'BILLING.ACTIONS.SUBSCRIBE'"
            (click)="navigateToPlans()"></sxw-button>

          <sxw-button
            *ngIf="canCancelSubscription"
            theme="sxw-theme"
            severity="danger"
            [outlined]="true"
            label="BILLING.ACTIONS.CANCEL_SUBSCRIPTION"
            (click)="cancelMySubscription()"></sxw-button>
        </div>
      </div>
    </div>
  </section>

  <section class="section">
    <div class="section-header">
      <h2 class="section-label">
        {{ "BILLING.PAYMENT_METHOD_TITLE" | translate }}
      </h2>
    </div>
    <div class="section-content">
      <app-payment-methods-list
        [paymentMethods]="paymentMethods()"
        [showAddButton]="true"
        [showViewButton]="true"
        (onOpenAddPaymentMethod)="openAddPaymentMethod()"
        (onViewPaymentMethod)="openViewPaymentMethod($event)"></app-payment-methods-list>
    </div>
  </section>

  <section class="section columns-section">
    <div class="section-header">
      <h2 class="section-label">
        {{ "BILLING.HISTORY_TITLE" | translate }}
      </h2>
    </div>

    <div class="section-content">
      <sxw-table class="full-table" theme="primary-theme" [config]="listInvoicesTableConfig" [pagination]="pagination"></sxw-table>
      <div class="footer flex-row-between pt-20 ms-20">
        <sxw-pagination #pagination></sxw-pagination>
      </div>
    </div>
  </section>
</div>
